<template>
  <div
    class="d-flex flex-column"
    style="height: 100vh;"
  >
    <div class="px-4 pt-4 mb-4">
      <div class="d-flex justify-content-between align-items-center">
        <h4 class="mb-0">
          {{ $t("tabs.chats.title") }}
        </h4>
        <b-dropdown
          variant="light"
          toggle-class="btn-sm dropdown-toggle btn-white"
          right
        >
          <template v-slot:button-content>
            <i class="ri-more-fill" />
          </template>
          <chats-download />
        </b-dropdown>
      </div>
    </div>

    <rooms-search />
    <select-assigned />
    <select-status />
    <!-- user-status /-->
    <rooms-list />
  </div>
</template>

<script>
import RoomsSearch from "./Search/SearchRoomsComponents";
import RoomsList from "./List/ListRoomsComponents";
import ChatsDownload from "./Helpers/ExportRoomsComponents";
import SelectAssigned from "./Helpers/SelectAssignedRoomsComponents";
import SelectStatus from "./Helpers/SelectStatusRoomsComponents";

export default {
  name: 'RoomsChats',
  components: {
    ChatsDownload,
    RoomsSearch,
    RoomsList,
    SelectAssigned,
    SelectStatus,
  },
};
</script>

<style lang="scss" scoped>
</style>






